import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { PostsService } from '../shared/services/posts.service';
import { IPost } from '../shared/models/ipost';

@Component({
  selector: 'app-post-detail',
  templateUrl: './post-detail.component.html',
  styleUrls: ['./post-detail.component.scss']
})
export class PostDetailComponent implements OnInit {

  public post: IPost;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private _postsService: PostsService ) { }

  ngOnInit() {
     const id = this.route.snapshot.params['id'];
     this._postsService.getPosts(1).subscribe(
      data => {
        this.post = data.find(m => m.id === id);
      },
      err => console.error(err),
      () => console.log('completed')
     );
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/post-detail/post-detail.component.ts